<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FiiHl7/tc-custom/9781446359815.jpg?1726519427172" alt="This image is the cover for the book Creative Photography Ideas: Using Adobe Photoshop"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Creative Photography Ideas: Using Adobe Photoshop
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Composites and further special effects</i> is an excerpt from <i>Creative Photography Ideas Using Photoshop</i> which presents 75 comprehensive workshops that have been specifically designed for photographers; each offers a clever and creative technique that can be immediately applied.</p><p><i>Composites and further special effects</i> workshops focus specifically on creating composites; from dropping in a sky to producing sunbeams, using multiple files, blending mode, refine edge, the gradient tool, multiple layers. There are plenty of creative ideas that will take your photography that little bit further from creating a 'joiner' or 'still movie' to joining two landscapes and creating a mirror image.</p><p>Each workshop offers ingenious creative techniques to immediately enhance images in Adobe Photoshop.</p><p>From basic techniques to more advanced, all guidance is ‘best practice’ and shown via clear explanatory texts, photographs, ‘before, during and after’ manipulations and screen grabs.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tony Worobiec
      </h2>
      
      <p class="authorDescription body article"><P><B>Tony Worobiec</B> is author of several photography titles. He has won numerous awards and his work is held in collections throughout the world. He is regular contributor to photography magazines and has taught photoshop for the prestigious Royal Photographic Society.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e5b09b90